import { BaseDto } from "../base/baseDto.model";

export class EstadoCivilDto extends BaseDto{
}
